import { useState } from "react";
import {
  Table,
  Space,
  Button,
  message,
  Modal,
} from "antd";
import CurrencyModalForm from "./CurrencyModalForm";
import CurrencyService from "../../../services/CurrencyService.js";

const getColumns = (setCurrencyTarget, showModalForm, showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "150px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Simbolo",
      dataIndex: "shortName",
      width: "150px",
      key: "shortName",
      render: (text, record) => <span>{record.shortName}</span>,
    },
    {
      title: "Acciones",
      key: "action",
      width: "50px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setCurrencyTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setCurrencyTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function Currency({ list = [], getData, setCurrencys }) {
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [currencyTarget, setCurrencyTarget] = useState(null);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    //console.log('curren', currencyTarget)
    CurrencyService.deleteCurrency(currencyTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Moneda eliminada.", 3);
          handleCancelDelete();
          handleOkForm();
        } else {
          message.error(
            "No se pudo eliminar la moneda. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setCurrencyTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setCurrencyTarget(null);
        setIsModalFormVisible(false);
        setCurrencys(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de monedas.", 5);
      });
  };

  const handleCancelForm = () => {
    setCurrencyTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{marginBottom:"1em"}}
      >
        +Registrar nueva moneda
      </Button>
      <Table
        columns={getColumns(setCurrencyTarget, showModalForm, showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <CurrencyModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          currencyTarget={currencyTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Moneda"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar la moneda{" "}
            <strong>
              {currencyTarget?.name + " - " + currencyTarget?.shortName}
            </strong>
            ?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
